export default __webpack_public_path__ + "static/media/bg-motorcycle-logistics-center.bf1189f7.jpg";